import { useQuery, gql } from "@apollo/client";
import { NxtbnDrawer } from "../../components";

const GET_STOCK_RESERVATION_DETAILS = gql`
  query GetStockReservationDetails($id: ID!) {
    stockReservation(id: $id) {
      createdAt
      dbId
      lastModified
      purpose
      quantity
      stock {
        incoming
        lastModified
        quantity
        reserved
        warehouse {
          name
        }
        productVariant {
          displayName
        }
      }
    }
  }
`;

interface StockDetailsViewProps {
  instance: any;
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
}

function StockReservationDetailsView({ instance, isOpen, onClose, refresh }: StockDetailsViewProps) {
  const { data, loading, error, refetch } = useQuery(GET_STOCK_RESERVATION_DETAILS, {
    variables: { id: instance },
    notifyOnNetworkStatusChange: true,
  });


  const stockReservation = data?.stockReservation;
  const stock = stockReservation?.stock;

  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title="Stock Transfer Details">
      <div className="p-6 space-y-6">
        <section className="bg-gray-50 p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-800">General Information</h3>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <h4 className="text-sm font-medium text-gray-600">Purpose</h4>
              <p className="text-sm text-gray-800">{stockReservation?.purpose || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Reserved Quantity</h4>
              <p className="text-sm text-gray-800">{stockReservation?.quantity || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Created At</h4>
              <p className="text-sm text-gray-800">{new Date(stockReservation?.createdAt).toLocaleString() || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Last Modified</h4>
              <p className="text-sm text-gray-800">{new Date(stockReservation?.lastModified).toLocaleString() || "N/A"}</p>
            </div>
          </div>
        </section>

        <section className="bg-gray-50 p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-800">Stock Details</h3>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <h4 className="text-sm font-medium text-gray-600">Product Variant</h4>
              <p className="text-sm text-gray-800">{stock?.productVariant.displayName || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Incoming</h4>
              <p className="text-sm text-gray-800">{stock?.incoming || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Quantity</h4>
              <p className="text-sm text-gray-800">{stock?.quantity || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-600">Reserved</h4>
              <p className="text-sm text-gray-800">{stock?.reserved || "N/A"}</p>
            </div>
            <div className="col-span-2">
              <h4 className="text-sm font-medium text-gray-600">Warehouse</h4>
              <p className="text-sm text-gray-800">{stock?.warehouse.name || "N/A"}</p>
            </div>
          </div>
        </section>
      </div>
    </NxtbnDrawer>
  );
}

export default StockReservationDetailsView;
